module.exports = __webpack_public_path__ + "static/media/overview-selected.344e71d3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/styles/images/sp/overview-selected.svg
// module id = 252
// module chunks = 0